import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinbhorepune() {



const cardData =
  {
    keyword: 'Bus On Rent in Bhor Pune',
    heading: 'Sanavi Travels: Bus On Rent in Bhor Pune',
    headingDescription: 'Sanavi Travels offers dependable, comfortable, and affordable Bus On Rent in Bhor Pune, catering to a wide range of group travel needs including weddings, corporate travel, school and college trips, picnics, religious tours, social functions, and outstation journeys. Bhor is a scenic taluka in Pune district, known for its natural beauty, hills, dams, temples, and strong rural connectivity to Pune city and surrounding regions. Due to frequent travel for family functions, tourism, education, agriculture-related movement, and religious visits, organized group transportation plays an important role in Bhor. To support these diverse travel requirements, Sanavi Travels provides a well-maintained fleet of AC buses, Non-AC buses, luxury coaches, mini buses, and high-capacity buses suitable for both hilly roads and long-distance highway travel. Each bus is equipped with clean interiors, comfortable cushioned seating, smooth suspension, proper ventilation, and adequate luggage space to ensure a safe and relaxed journey even on winding rural routes. Our experienced drivers are well familiar with Bhor roads, ghat sections, village connectivity, and Pune highways, ensuring punctual pickups, disciplined driving, and smooth coordination throughout the journey. With transparent pricing, flexible rental plans, and 24/7 customer support, Sanavi Travels makes bus rental in Bhor Pune easy, economical, and completely stress-free for every group.',

    top: 'Top Places to Visit in and Around Bhor Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhor Town",
    "description": "Bhor is a historic town and taluka headquarters surrounded by hills, rivers, and fertile landscapes. It serves as a center for education, trade, and social activities for nearby villages. Bus rentals are commonly used for daily group travel, events, and inter-village connectivity, ensuring organized transportation for residents and visitors."
  },
  {
    "title": "Bhatghar Dam",
    "description": "Bhatghar Dam is one of the oldest dams in Maharashtra and a major attraction near Bhor. Surrounded by scenic hills and water views, it attracts tourists, students, and picnic groups. Bus rentals are ideal for group visits, educational tours, and leisure trips to the dam area."
  },
  {
    "title": "Neera River Region",
    "description": "The Neera River flows near Bhor and supports agriculture and local livelihoods. Groups often visit nearby riverbanks and villages for cultural, social, and agricultural activities, making bus hire a convenient option for organized travel."
  },
  {
    "title": "Religious Temples and Spiritual Sites",
    "description": "Bhor and surrounding villages have several temples and spiritual centers that attract devotees throughout the year. Bus rentals are widely used for group pilgrimages, festivals, and religious gatherings."
  },
  {
    "title": "Hilly and Ghat Areas",
    "description": "Bhor is surrounded by hills and ghats that offer scenic views and peaceful environments. Nature lovers, students, and travel groups often plan trips to these areas, where bus rentals provide safe and comfortable group transportation."
  },
  {
    "title": "Educational Institutions",
    "description": "Schools and colleges in and around Bhor regularly organize excursions, competitions, and educational visits. Hiring buses ensures safe, punctual, and well-managed transportation for students and staff."
  },
  {
    "title": "Wedding and Event Venues",
    "description": "Bhor has marriage halls, community spaces, and open grounds used for weddings and social functions. Bus rentals help families manage guest transportation efficiently, especially for large rural gatherings."
  },
  {
    "title": "Village Connectivity",
    "description": "Numerous villages surround Bhor, requiring reliable group transport for social, agricultural, and administrative purposes. Bus hire services help connect villages with town centers and Pune city."
  },
  {
    "title": "Tourism and Picnic Spots",
    "description": "The natural surroundings of Bhor make it a popular base for picnic trips and short tours. Schools, offices, and families frequently hire buses for leisure travel to nearby destinations."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Bhor serves as a convenient starting point for outstation journeys to Pune, Satara, Mahabaleshwar, and other regions. Bus rentals offer comfort, safety, and affordability for long-distance group travel."
  }
]
,



"services": [
{
"name": "Bus On Rent in Bhor Pune",
"description": "Bus On Rent in Bhor Pune provides reliable, spacious, and professionally managed buses suitable for weddings, corporate travel, school trips, picnics, religious tours, village travel, and outstation journeys. The buses are designed to handle rural roads, ghat sections, and highways with ease, featuring clean interiors, cushioned seating, smooth suspension, proper airflow, and sufficient luggage space. Experienced drivers familiar with Bhor routes, village connectivity, and Pune highways ensure punctual pickups, safe driving, and smooth coordination. This service is ideal for families, institutions, offices, and organizations looking for stress-free group transportation in and around Bhor."
},
{
"name": "Bus Hire Bhor",
"description": "Bus Hire Bhor offers flexible and economical bus rental solutions for local travel, full-day bookings, events, and long-distance trips. With disciplined drivers and well-maintained vehicles, group travel becomes organized, safe, and comfortable."
},
{
"name": "AC Bus Rental Bhor Pune",
"description": "AC Bus Rental Bhor Pune ensures a cool and comfortable journey during summer and long trips. Air-conditioned buses help reduce fatigue and provide a pleasant experience for passengers traveling on hilly and highway routes."
},
{
"name": "Non AC Bus on Rent Bhor",
"description": "Non AC Bus on Rent Bhor is a budget-friendly option suitable for short routes, school trips, village travel, and economical group transportation without compromising safety."
},
{
"name": "Luxury Bus on Rent Bhor Pune",
"description": "Luxury Bus on Rent Bhor Pune delivers a premium travel experience with superior interiors, enhanced seating comfort, and professional presentation, making it ideal for weddings, VIP guests, and corporate executives."
},
{
"name": "Mini Bus Hire Bhor",
"description": "Mini Bus Hire Bhor is perfect for small to medium-sized groups such as families, office teams, and students, offering flexibility, affordability, and easy maneuverability on narrow rural roads."
},
{
"name": "32 Seater Bus on Rent Bhor",
"description": "32 Seater Bus on Rent Bhor is ideal for school excursions, corporate outings, religious tours, and medium-sized group travel, balancing seating capacity with comfort."
},
{
"name": "35 Seater Bus Hire Bhor",
"description": "35 Seater Bus Hire Bhor supports large group transportation needs such as weddings, community events, political programs, and long-distance tours with reliable performance."
},
{
"name": "Bus on Rent Bhor for Wedding",
"description": "Bus on Rent Bhor for Wedding ensures smooth and coordinated transportation for wedding guests, helping families manage large rural gatherings without travel stress."
},
{
"name": "Bus on Rent Bhor for Corporate",
"description": "Bus on Rent Bhor for Corporate provides structured and professional transport solutions for office outings, meetings, training programs, and corporate events."
},
{
"name": "Bus on Rent Bhor for Picnic",
"description": "Bus on Rent Bhor for Picnic offers safe and enjoyable group travel for schools, offices, and families planning leisure and educational outings."
},
{
"name": "Bus Rental Bhor Outstation",
"description": "Bus Rental Bhor Outstation provides dependable long-distance transportation to Pune, Satara, Mahabaleshwar, Kolhapur, and other destinations with comfort and safety."
},
{
"name": "Bus Hire Bhor with Driver",
"description": "Bus Hire Bhor with Driver offers chauffeur-driven buses where experienced drivers manage routes, traffic, and schedules professionally."
},
{
"name": "Affordable Bus Rental Bhor Pune",
"description": "Affordable Bus Rental Bhor Pune delivers cost-effective transportation solutions without compromising cleanliness, comfort, or reliability."
},
{
"name": "Best Bus Service Bhor",
"description": "Best Bus Service Bhor is trusted for punctual service, clean buses, transparent pricing, and customer satisfaction delivered by Sanavi Travels."
}
],
"tableData": [
["Bus On Rent in Bhor Pune", "Bus Hire Bhor"],
["AC Bus Rental Bhor", "Non AC Bus Hire Bhor"],
["Luxury Bus Bhor", "Mini Bus Hire Bhor"],
["32 Seater Bus Bhor", "35 Seater Bus Bhor"],
["Wedding Bus Bhor", "Corporate Bus Bhor"],
["Picnic Bus Bhor", "Outstation Bus Bhor"],
["Bus Hire Bhor with Driver", "Affordable Bus Rental Bhor"],
["Best Bus Service Bhor", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Bhor Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides dependable and professional bus rental services across Bhor Pune."
  },
  {
    "WhyChooseheading": "Experienced Rural Route Drivers",
    "WhyChoosedescription": "Drivers are well familiar with Bhor roads, village routes, ghats, and highways."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Fleet",
    "WhyChoosedescription": "Buses are regularly serviced and cleaned for passenger comfort."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear pricing with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Round-the-clock assistance for bookings and travel coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Hourly, full-day, event-based, and outstation rental options available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are sanitized before every trip."
  },
  {
    "WhyChooseheading": "On-Time and Reliable Service",
    "WhyChoosedescription": "Guaranteed punctual pickups and smooth journey management."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Bhor Pune?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Bhor Pune.'
  },
  {
    question: 'What types of buses are available in Bhor?',
    answer: 'AC buses, Non AC buses, mini buses, luxury buses, 32-seater and 35-seater buses are available.'
  },
  {
    question: 'Is bus hire available for weddings and picnics?',
    answer: 'Yes, dedicated buses are available for weddings, picnics, and group events.'
  },
  {
    question: 'Can I book a bus for outstation travel from Bhor?',
    answer: 'Yes, outstation bus rental services are available from Bhor.'
  },
  {
    question: 'Are the buses cleaned and sanitized?',
    answer: 'Yes, all buses are cleaned and sanitized before every journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Jadhav',
    feedback: 'We booked a bus from Bhor for a family function. Very comfortable journey and good driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Kavita Patil',
    feedback: 'Sanavi Travels provided excellent bus service for our picnic trip from Bhor.',
    rating: 5
  }
];






















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Bhor Pune - Sanavi Travels",
  "description": "Sanavi Travels offers bus on rent in Bhor Pune for weddings, corporate travel, picnics, and outstation trips. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};









  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | Bus On Rent in Bhor Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Bhor Pune with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/240.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinbhorepune;